export function GradientBackground() {
  return (
    <div
      className="fixed inset-0 -z-10"
      aria-hidden="true"
    >
      {/* Base background */}
      <div className="absolute inset-0 bg-sc-bg-page" />
      {/* Green mesh — top left */}
      <div
        className="absolute inset-0"
        style={{ background: "var(--sc-mesh-1)" }}
      />
      {/* Blue mesh — bottom right */}
      <div
        className="absolute inset-0"
        style={{ background: "var(--sc-mesh-2)" }}
      />
      {/* Dark grid overlay (dark mode only) */}
      <div className="absolute inset-0 opacity-0 dark:opacity-[0.02] bg-[linear-gradient(rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:20px_20px]" />
    </div>
  );
}
